/*
 * Deterministic formatters: they give the same output on the server and in
 * every browser, so formatted values never cause a hydration mismatch.
 */

// Spanish convention: no thousands separator below 10.000, a dot from there on.
export const formatPrice = (value: number): string => {
    const rounded = Math.round(value)
    const digits = String(Math.abs(rounded))
    const grouped = digits.length > 4 ? digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : digits

    return `${rounded < 0 ? '-' : ''}${grouped} €`
}

export const pluralize = (count: number, singular: string, plural: string): string => {
    return count === 1 ? singular : plural
}

// "sábado, 14 de noviembre de 2026" from a YYYY-MM-DD value. Uses Intl, so call it
// only in event-driven UI or on the server, never in the first render.
export const formatLongDate = (dateKey: string): string => {
    const date = new Date(`${dateKey}T00:00:00Z`)

    if (Number.isNaN(date.getTime())) return dateKey

    return new Intl.DateTimeFormat('es-ES', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC'
    }).format(date)
}
